<template>
  <div id="app">
    <router-view/>
  </div>

  <!-- Organization-Details modal -->
  <organization-modal
      :org-id="showOrganizationModal"
      v-if="!!showOrganizationModal"
      @modal-closed="showOrganizationModal = undefined"
      @goto-user="gotoUser"/>

  <!-- User-Synchronization-State modal -->
  <synchronization-modal
      v-if="!!showUserSyncModal && !showOrganizationModal"
      @modal-closed="showUserSyncModal = undefined"
      @organization-clicked="showOrganizationModal = $event"
      @sync-updated="$toast.success($t('adm.page.sync.alertSyncUpdated'))"/>

  <video-tutorials v-if="showTutorialsModal" @modal-closed="showTutorialsModal = false"/>

</template>

<script lang="ts">
import OrganizationModal from '@/views/Organizations/view/index.vue';
import SynchronizationModal from '@/views/Users/sync/index.vue';
import { mapState, mapWritableState } from 'pinia';
import useAppStore from '@/components/store';
import { i18n } from '@/lang';
import VideoTutorials from '@/views/VideoTutorials.vue';

export default {
  name: 'App',
  components: {
    VideoTutorials, SynchronizationModal, OrganizationModal,
  },
  computed: {
    // inject state getters
    ...mapState(useAppStore, {
      profile: 'principal',
    }),
    ...mapWritableState(useAppStore, {
      showOrganizationModal: 'showOrganizationModal', // modal-control -> set org-id to show modal
      showUserSyncModal: 'showUserSyncModal', // modal-control -> set UserData to show modal
      showTutorialsModal: 'showTutorialsModal',
    }),
  },
  methods: {
    gotoUser(id: string) {
      // close organization modal if open
      this.showOrganizationModal = undefined;
      // goto User page
      this.$router.push(`/${i18n.global.locale}/members/${id}`);
    },
  },
};
</script>
